// src/styles/GlobalStyle.js
import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 300;
    src: url('https://fonts.gstatic.com/s/roboto/v27/KFOlCnqEu92Fr1MmSU5vAw.ttf') format('truetype');
  }

  body {
    font-family: 'Inter', sans-serif;
    background-color: #eff3f7;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Roboto', sans-serif; /* Defina para usar Roboto */
    font-weight: 300; /* Peso Light */
  }
`;

export default GlobalStyle;
